import React from 'react';
import { Flex, IconV2, TextV2 } from '@withjoy/joykit';
import { Warning } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import type { RegistryCurrencySwitchNoticeProps } from './RegistryCurrencySwitchNotice.types';

/** Shown by both payout setup forms (registry and website cash funds) when the chosen country moves the registry currency. */
export const RegistryCurrencySwitchNotice: React.FC<RegistryCurrencySwitchNoticeProps> = ({ countryLabel, currencyCode }) => {
  const { tq } = useTranslation('yourRegistry');
  return (
    <Flex
      padding={5}
      borderRadius={3}
      borderWidth="1px"
      borderStyle="solid"
      borderColor="info3"
    >
      <IconV2
        color="info5"
        marginRight={2}
      >
        <Warning />
      </IconV2>
      <TextV2
        typographyVariant="label2"
        color="mono14"
      >
        {tq`Selecting ${countryLabel} will set your registry currency to ${currencyCode}. Existing cash fund goals and gift prices keep their numbers and are not converted, so check them after saving. Cash funds that already have contributions stay in their current currency and stop taking card payments. Joy catalog items are not affected. Your currency will be locked once saved.`}
      </TextV2>
    </Flex>
  );
};
